/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Annualita } from '../model/annualita';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AnnualitService {

    protected basePath = 'https://demo-api.mensapp.it/gestione-mense';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Permette ad un account Amministratore di censire una nuova annualita&#x27;.
     * Crea una nuova annualità scolastica nel sistema. Operazione riservata agli amministratori.
     * @param anno_di_riferimento 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addAnnualita(anno_di_riferimento: string, observe?: 'body', reportProgress?: boolean): Observable<Annualita>;
    public addAnnualita(anno_di_riferimento: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Annualita>>;
    public addAnnualita(anno_di_riferimento: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Annualita>>;
    public addAnnualita(anno_di_riferimento: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (anno_di_riferimento === null || anno_di_riferimento === undefined) {
            throw new Error('Required parameter anno_di_riferimento was null or undefined when calling addAnnualita.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (anno_di_riferimento !== undefined && anno_di_riferimento !== null) {
            queryParameters = queryParameters.set('anno_di_riferimento', <any>anno_di_riferimento);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Annualita>('post',`${this.basePath}/api/v1/annualita/add`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce tutte le annualita&#x27; censite.
     * Recupera l&#x27;elenco completo di tutte le annualità scolastiche presenti nel sistema.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllAnnualita(observe?: 'body', reportProgress?: boolean): Observable<Array<Annualita>>;
    public getAllAnnualita(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Annualita>>>;
    public getAllAnnualita(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Annualita>>>;
    public getAllAnnualita(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Annualita>>('get',`${this.basePath}/api/v1/annualita/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce un annualita ricercata per anno di riferimento.
     * Cerca e restituisce un&#x27;annualità scolastica in base all&#x27;anno di riferimento fornito (es. &#x27;2024/2025&#x27;).
     * @param anno_di_riferimento 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAnnualitaByAnnoDiRiferimento(anno_di_riferimento: string, observe?: 'body', reportProgress?: boolean): Observable<Annualita>;
    public getAnnualitaByAnnoDiRiferimento(anno_di_riferimento: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Annualita>>;
    public getAnnualitaByAnnoDiRiferimento(anno_di_riferimento: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Annualita>>;
    public getAnnualitaByAnnoDiRiferimento(anno_di_riferimento: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (anno_di_riferimento === null || anno_di_riferimento === undefined) {
            throw new Error('Required parameter anno_di_riferimento was null or undefined when calling getAnnualitaByAnnoDiRiferimento.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (anno_di_riferimento !== undefined && anno_di_riferimento !== null) {
            queryParameters = queryParameters.set('anno_di_riferimento', <any>anno_di_riferimento);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Annualita>('get',`${this.basePath}/api/v1/annualita`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce l&#x27;annualita in corso se settata, altrimenti null.
     * Recupera l&#x27;annualità scolastica corrente impostata nel sistema. Restituisce null se nessuna annualità è stata impostata come in corso.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAnnualitaInCorso(observe?: 'body', reportProgress?: boolean): Observable<Annualita>;
    public getAnnualitaInCorso(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Annualita>>;
    public getAnnualitaInCorso(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Annualita>>;
    public getAnnualitaInCorso(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Annualita>('get',`${this.basePath}/api/v1/annualita/in-corso`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account Amministratore di settare un annualita&#x27; in corso.
     * Imposta un&#x27;annualità scolastica come quella attualmente in corso nel sistema. Operazione riservata agli amministratori.
     * @param anno_di_riferimento 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public settaAnnualitaInCorso(anno_di_riferimento: string, observe?: 'body', reportProgress?: boolean): Observable<Annualita>;
    public settaAnnualitaInCorso(anno_di_riferimento: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Annualita>>;
    public settaAnnualitaInCorso(anno_di_riferimento: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Annualita>>;
    public settaAnnualitaInCorso(anno_di_riferimento: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (anno_di_riferimento === null || anno_di_riferimento === undefined) {
            throw new Error('Required parameter anno_di_riferimento was null or undefined when calling settaAnnualitaInCorso.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (anno_di_riferimento !== undefined && anno_di_riferimento !== null) {
            queryParameters = queryParameters.set('anno_di_riferimento', <any>anno_di_riferimento);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Annualita>('post',`${this.basePath}/api/v1/annualita/in-corso`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
